'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _userService = require('../user/userService');

var _notificationActions = require('./notificationActions');

var _boardService = require('../element/board/boardService');

var _notificationPollManagerSelector = require('./notificationPollManagerSelector');

var _notificationPollManagerSelector2 = _interopRequireDefault(_notificationPollManagerSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// poll for new notifications every five minutes
var POLL_MODIFICATIONS_DELAY = 1000 * 60 * 5;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchModified: function fetchModified() {
            return dispatch((0, _notificationActions.fetchModifiedBoards)());
        },
        fetchNotificationUsers: function fetchNotificationUsers(users) {
            return dispatch((0, _userService.fetchUsers)(users));
        },
        fetchNotificationBoards: function fetchNotificationBoards(boardIds) {
            return dispatch((0, _boardService.fetchBoards)({ boardIds: boardIds, loadAncestors: false }));
        }
    };
};

var NotificationPollWindow = (_dec = (0, _reactRedux.connect)(_notificationPollManagerSelector2.default, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(NotificationPollWindow, _React$Component);

    function NotificationPollWindow() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, NotificationPollWindow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationPollWindow.__proto__ || Object.getPrototypeOf(NotificationPollWindow)).call.apply(_ref, [this].concat(args))), _this), _this.startPollNotificationsInterval = function () {
            _this.pollTimer = setInterval(function () {
                return _this.props.fetchModified();
            }, POLL_MODIFICATIONS_DELAY);
        }, _this.stopPollNotificationsInterval = function () {
            if (_this.pollTimer) {
                clearInterval(_this.pollTimer);
                _this.pollTimer = null;
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(NotificationPollWindow, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                fetchModified = _props.fetchModified,
                isGuest = _props.isGuest;

            if (isGuest) return;

            fetchModified();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props2 = this.props,
                notifications = _props2.notifications,
                fetchNotificationUsers = _props2.fetchNotificationUsers,
                fetchedTime = _props2.fetchedTime,
                forcedPoll = _props2.forcedPoll,
                fetchModified = _props2.fetchModified,
                notificationUserIds = _props2.notificationUserIds;


            if (fetchedTime !== nextProps.fetchedTime) {
                this.stopPollNotificationsInterval();
                this.startPollNotificationsInterval();
            }

            if (forcedPoll !== nextProps.forcedPoll) {
                this.stopPollNotificationsInterval();
                fetchModified();
            }

            if (notifications !== nextProps.notifications) {
                if (!notificationUserIds.length) return;
                fetchNotificationUsers(notificationUserIds);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopPollNotificationsInterval();
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return NotificationPollWindow;
}(_react2.default.Component)) || _class);


NotificationPollWindow.propTypes = {
    isGuest: _react2.default.PropTypes.bool,
    fetchedTime: _react2.default.PropTypes.number,
    forcedPoll: _react2.default.PropTypes.number,

    notifications: _react2.default.PropTypes.object,
    notificationUserIds: _react2.default.PropTypes.array,

    fetchNotificationUsers: _react2.default.PropTypes.func,
    fetchNotificationBoards: _react2.default.PropTypes.func,
    fetchModified: _react2.default.PropTypes.func
};

exports.default = NotificationPollWindow;


//////////////////
// WEBPACK FOOTER
// ./src/client/notifications/NotificationPollManager.js
// module id = 2035
// module chunks = 0